import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class PentBox extends Vue {
	@Prop() icon!: string; // Material icon name
	@Prop() title!: string;
	@Prop() description?: string;
	@Prop() onClick?: Function;

	clicked() {
		if (this.onClick) {
			this.onClick();
		}
	}
}
